// © 2026 SDGP.lk
// Licensed under the GNU Affero General Public License v3.0 or later,
// with an additional restriction: Non-commercial use only.
// See <https://www.gnu.org/licenses/agpl-3.0.html> for details.

// AUTO-GENERATED FILE - SAFE FOR FRONTEND USE
// Enums extracted from Prisma schema

export enum Role {
  ADMIN = "ADMIN",
  MODERATOR = "MODERATOR",
  DEVELOPER = "DEVELOPER",
  STUDENT = "STUDENT",       // Default role assigned to all OIDC sign-ins
}

export enum AssociationType {
  PROJECT_TYPE = "PROJECT_TYPE",
  PROJECT_DOMAIN = "PROJECT_DOMAIN",
  PROJECT_SDG = "PROJECT_SDG",
  PROJECT_TECH = "PROJECT_TECH",
  AWARD = "AWARD",
}

export enum ProjectStatusEnum {
  IDEA = "IDEA",
  MVP = "MVP",
  RESEARCH = "RESEARCH",
  DEPLOYED = "DEPLOYED",
  STARTUP = "STARTUP",
}

export enum ProjectDomainEnum {
  AI = "AI",
  ML = "ML",
  AR_VR = "AR_VR",
  BLOCKCHAIN = "BLOCKCHAIN",
  IOT = "IOT",
  HEALTHTECH = "HEALTHTECH",
  FINTECH = "FINTECH",
  EDTECH = "EDTECH",
  AGRITECH = "AGRITECH",
  ECOMMERCE = "ECOMMERCE",
  SOCIAL = "SOCIAL",
  GAMING = "GAMING",
  SECURITY = "SECURITY",
  DATA_ANALYTICS = "DATA_ANALYTICS",
  ENTERTAINMENT = "ENTERTAINMENT",
  SUSTAINABILITY = "SUSTAINABILITY",
}

export enum ProjectTypeEnum {
  MOBILE = "MOBILE",
  WEB = "WEB",
  HARDWARE = "HARDWARE",
  DESKTOP = "DESKTOP",
  WEARABLE = "WEARABLE",
  EXTENSION = "EXTENSION",
}

export enum SDGGoalEnum {
  NO_POVERTY = "NO_POVERTY",
  ZERO_HUNGER = "ZERO_HUNGER",
  GOOD_HEALTH = "GOOD_HEALTH",
  QUALITY_EDUCATION = "QUALITY_EDUCATION",
  GENDER_EQUALITY = "GENDER_EQUALITY",
  CLEAN_WATER = "CLEAN_WATER",
  AFFORDABLE_ENERGY = "AFFORDABLE_ENERGY",
  DECENT_WORK = "DECENT_WORK",
  INDUSTRY_INNOVATION = "INDUSTRY_INNOVATION",
  REDUCED_INEQUALITIES = "REDUCED_INEQUALITIES",
  SUSTAINABLE_CITIES = "SUSTAINABLE_CITIES",
  RESPONSIBLE_CONSUMPTION = "RESPONSIBLE_CONSUMPTION",
  CLIMATE_ACTION = "CLIMATE_ACTION",
  LIFE_BELOW_WATER = "LIFE_BELOW_WATER",
  LIFE_ON_LAND = "LIFE_ON_LAND",
  PEACE_JUSTICE = "PEACE_JUSTICE",
  PARTNERSHIPS = "PARTNERSHIPS",
}

export enum TechStackEnum {
  REACT = "REACT",
  ANGULAR = "ANGULAR",
  VUE = "VUE",
  NODE = "NODE",
  PYTHON = "PYTHON",
  DJANGO = "DJANGO",
  FLASK = "FLASK",
  JAVA = "JAVA",
  SPRING = "SPRING",
  DOTNET = "DOTNET",
  PHP = "PHP",
  LARAVEL = "LARAVEL",
  ANDROID = "ANDROID",
  IOS = "IOS",
  FLUTTER = "FLUTTER",
  REACT_NATIVE = "REACT_NATIVE",
  FIREBASE = "FIREBASE",
  AWS = "AWS",
  MONGODB = "MONGODB",
  MYSQL = "MYSQL",
  POSTGRESQL = "POSTGRESQL",
  TENSORFLOW = "TENSORFLOW",
  PYTORCH = "PYTORCH",
  ARDUINO = "ARDUINO",
  RASPBERRY_PI = "RASPBERRY_PI",
  SVELTE = "SVELTE",
  KOTLIN = "KOTLIN",
  SWIFT = "SWIFT",
  RUBY = "RUBY",
  JAVASCRIPT = "JAVASCRIPT",
  TYPESCRIPT = "TYPESCRIPT",
  C_SHARP = "C_SHARP",
  C_PLUS_PLUS = "C_PLUS_PLUS",
  C = "C",
}

export enum SocialTypeEnum {
  LINKEDIN = "LINKEDIN",
  TWITTER = "TWITTER",
  INSTAGRAM = "INSTAGRAM",
  FACEBOOK = "FACEBOOK",
  YOUTUBE = "YOUTUBE",
  TIKTOK = "TIKTOK",
}

export enum ProjectApprovalStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum ApprovalStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}